function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 0H24V24H0V0z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4zM19.6 8.25L12.53 12.67C12.21 12.87 11.79 12.87 11.47 12.67L4.4 8.25A.85.85 0 1 1 5.3 6.81L12 11 18.7 6.81A.85.85 0 1 1 19.6 8.25z"
});

var SvgRoundEmail24px = function SvgRoundEmail24px(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
};

export default 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPkVtYWlsPC90aXRsZT48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDBWMHoiLz48cGF0aCBkPSJNMjAgNEg0Yy0xLjEgMC0xLjk5LjktMS45OSAyTDIgMThjMCAxLjEuOSAyIDIgMmgxNmMxLjEgMCAyLS45IDItMlY2YzAtMS4xLS45LTItMi0yem0tLjQgNC4yNWwtNy4wNyA0LjQyYy0uMzIuMi0uNzQuMi0xLjA2IDBMNC40IDguMjVjLS4yNS0uMTYtLjQtLjQzLS40LS43MiAwLS42Ny43My0xLjA3IDEuMy0uNzJMMTIgMTFsNi43LTQuMTljLjU3LS4zNSAxLjMuMDUgMS4zLjcyIDAgLjI5LS4xNS41Ni0uNC43MnoiLz48L3N2Zz4=';
export { SvgRoundEmail24px as ReactComponent };